import React from 'react';
import {noop} from 'lodash';

import ClientRole from '/component/partial/report/ClientRole';
import LastOrderedDate from '/component/partial/report/LastOrderedDate';
import OrdersListHeader from '/component/partial/report/OrdersListHeader';
import PeopleReportDataRenderer from '/component/partial/report/PeopleReportDataRenderer';
import ReportDataProvider from '/component/partial/report/ReportDataProvider';

import {generateOnRecordPress} from './AllFrontlineOrdersReport.util';
import reportPayload from './reportPayload';

import {useRecordsSorting} from '/context/RecordsSort/useRecordsSorting';

interface AllFrontlineOrdersContentProps {
  recordsShowPopover: () => void;
  recordsShowRecord: () => void;
  onOrderPress: () => void;
  showRecordPopover: () => void;
  loadingData: {
    total?: number;
  };
}

export const AllFrontlineOrdersContent = ({
  loadingData = {},
  showRecordPopover = noop,
  recordsShowPopover = noop,
  recordsShowRecord = noop,
  onOrderPress = noop,
}: AllFrontlineOrdersContentProps) => {
  const {isReadyToLoad, sortParam} = useRecordsSorting({
    recordsName: reportPayload.reportName,
  });

  if (!isReadyToLoad) {
    return null;
  }

  return (
    <ReportDataProvider
      {...reportPayload}
      dataRenderer={PeopleReportDataRenderer}
      dataRendererProps={{
        listHeaderComponent: OrdersListHeader,
        personRoleComponent: ClientRole,
        personInfoComponent: LastOrderedDate,
        onRecordPress: generateOnRecordPress({
          showRecordPopover,
          recordsShowPopover,
          recordsShowRecord,
          onOrderPress,
        }),
      }}
      loadingData={loadingData}
      reportParams={[{...sortParam.params}]}
    />
  );
};
